import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  CreateLegalAppendiceRequest,
  CreateLegalAppendiceResponse,
  GetLegalAppendicesRequest,
  GetLegalAppendicesResponse,
  DeleteLegalAppendiceRequest,
  DeleteLegalAppendiceResponse,
} from "../../models/LegalAppendice.model";
import { environment } from "../../environments";

// Create Legal Appendice
const API_URL = environment.apiUrl;
export const createLegalAppendice = createAsyncThunk<
  CreateLegalAppendiceResponse,
  CreateLegalAppendiceRequest,
  { rejectValue: string }
>(
  "legalAppendice/create",
  async (request, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_URL}Appendice/CreateAppendice`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(request),
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: CreateLegalAppendiceResponse = await response.json();

      if (!data.success)
        return rejectWithValue(data.message || "Failed to create legal appendice");
      return data;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "Unknown error"
      );
    }
  }
);
  

// Get Legal Appendices
export const getLegalAppendices = createAsyncThunk<
  GetLegalAppendicesResponse,
  GetLegalAppendicesRequest,
  { rejectValue: string }
>(
  "legalAppendice/getAll",
  async (request, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_URL}Appendice/GetLegalAppendices`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(request),
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: GetLegalAppendicesResponse = await response.json();

      if (!data.success)
        return rejectWithValue(data.message || "Failed to get legal appendices");
      return data;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "שגיאה בקבלת נספחים משפטיים"
      );
    }
  }
);

// Delete Legal Appendice
export const deleteLegalAppendice = createAsyncThunk<
  DeleteLegalAppendiceResponse,
  DeleteLegalAppendiceRequest,
  { rejectValue: string }
>(
  "legalAppendice/delete",
  async (request, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_URL}Appendice/DeleteLegalAppendice`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(request),
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: DeleteLegalAppendiceResponse = await response.json();

      if (!data.success)
        return rejectWithValue(data.message || "Failed to delete legal appendice");
      return data;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "שגיאה במחיקת נספח משפטי"
      );
    }
  }
);